import { Component } from 'react';
import type { WithContext, Thing, Organization } from 'schema-dts';
import { Helmet } from 'react-helmet-async';

export const SWSOrganizationSchema: Organization = {
  '@type': 'Organization',
  name: 'Simply Wall St',
};

export const SWSOrganizationAuthorSchema: Organization = {
  '@type': 'Organization',
  name: 'Simply Wall St',
  legalName: 'Simply Wall Street Pty Ltd',
  description:
    'Simply Wall St is a financial technology startup focused on providing unbiased, high-quality research coverage on every listed company in the world. Our research team consists of equity analysts with a public, market-beating track record.',
  url: 'https://simplywall.st/',
  logo: 'https://simplywall.st/news/images/sws-logo.svg',
};

/**
 * https://github.com/google/react-schemaorg/blob/master/src/json-ld.tsx
 *
 * This is a mod of the original due to Helmet not accepting dangerouslySetInnerHTML
 */
class DocumentSchema<T extends Thing> extends Component<{
  item: WithContext<T>;
}> {
  render() {
    const { item } = this.props;
    return (
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(item)}</script>
      </Helmet>
    );
  }
}

export default DocumentSchema;
